import { render, staticRenderFns } from "./EmployeeDebitDeduction.vue?vue&type=template&id=e2ab185a&scoped=true&"
import script from "./EmployeeDebitDeduction.vue?vue&type=script&lang=js&"
export * from "./EmployeeDebitDeduction.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeDebitDeduction.vue?vue&type=style&index=0&id=e2ab185a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ab185a",
  null
  
)

export default component.exports